import { render, staticRenderFns } from "./es-wangEditor.vue?vue&type=template&id=267794bc&scoped=true&"
import script from "./es-wangEditor.vue?vue&type=script&lang=js&"
export * from "./es-wangEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267794bc",
  null
  
)

export default component.exports